import Vue from 'vue';
import pretrade from './pretrade/pretrade.vue';
Vue.component('pretrade', pretrade);
